import React from 'react';
import {useEditor} from '@craftjs/core';
import {Transitioner} from 'components';

interface ISidebarRightEditorProps {}

const SidebarRightEditor = ({}: ISidebarRightEditorProps) => {
  const {selected} = useEditor(state => {
    const [currentNodeId] = state.events.selected;
    let selected;
    if (currentNodeId) {
      selected = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings: state.nodes[currentNodeId].related && state.nodes[currentNodeId].related.settings,
      };
    }
    return {selected};
  });

  if (selected) {
    return (
      <Transitioner key={selected.id} fromY={-20}>
        <div className="relative flex flex-col gap-4 mb-6">{selected.settings && React.createElement(selected.settings)}</div>
      </Transitioner>
    );
  }

  return null;
};

export default React.memo(SidebarRightEditor);
